import { render, staticRenderFns } from "./SendMailSuccess.vue?vue&type=template&id=6c402615&scoped=true&"
import script from "./SendMailSuccess.vue?vue&type=script&lang=js&"
export * from "./SendMailSuccess.vue?vue&type=script&lang=js&"
import style0 from "./SendMailSuccess.vue?vue&type=style&index=0&id=6c402615&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c402615",
  null
  
)

export default component.exports